export const isFree = (id: string) => id === 'FREE';
export const isFreeTrial = (id: string) => id === 'FREE_TRIAL';

export const isPro = (id: string) => id === 'PRO';
export const isBusiness = (id: string) =>
  id === 'BUSINESS' ||
  id === 'BUSINESS_SIX_MONTHS' ||
  id === 'BUSINESS_TWELVE_MONTHS' ||
  id === 'BUSINESS_THREE_MONTHS';
export const isEnterprise = (id: string) => id === 'ENTERPRISE';
export const isUnlimited = (id: string) => id === 'UNLIMITED';
export const isSalesLed = (id: string) => id === 'SALES_LED_GROWTH';
export const isGrowth = (id: string) =>
  id === 'GROWTH_MONTHLY' || id === 'GROWTH_ANNUAL';
export const isStarter = (id: string) =>
  id === 'STARTER_MONTHLY' || id === 'STARTER_ANNUAL';

// none Stripe, sold by our sales representatives
export const isEssentials = (id: string) => essentials_plans.includes(id);

// Stripe based
export const isEventsEcommerce = (id: string) =>
  id === 'EVENTS_ECOMMERCE_100' ||
  id === 'EVENTS_ECOMMERCE_500' ||
  id === 'EVENTS_ECOMMERCE_1000';

export const isEventsPro = (id: string) =>
  ['SALES_LED_PRO', 'SALES_LED_PRO_PLUS', 'SALES_LED_PRO_ENTERPRISE'].includes(
    id,
  );

export const isEventsEcommercePro = (id: string) =>
  id === 'EVENTS_ECOMMERCE_PRO' || id === 'EVENTS_ECOMMERCE_PRO_PLUS';

/**
 * To distinguish between sales-led and self-serve (ecommerce) plans
 *
 * @example
 * isEventsProSalesLed('SALES_LED_PRO') // true
 * isEventsProSalesLed('EVENTS_ECOMMERCE_PRO') // false
 */
export const isEventsProSalesLed = (id: string) => id.startsWith('SALES_LED');

export const isAppsumo = (id: string) => {
  return appsumo_plans.includes(id);
};

export const isAdvanced = (id: string) => {
  if (isUnlimited(id) || isPro(id) || isBusiness(id) || isEnterprise(id)) {
    return true;
  } else {
    return false;
  }
};

export const isSpecial = (id: string) => {
  if (isAppsumo(id) || isUnlimited(id) || isPro(id)) {
    return true;
  } else {
    return false;
  }
};

export const free_plans = ['FREE'];
export const free_trial_plans = ['FREE_TRIAL'];
export const pro_plans = ['PRO'];
export const events_pro_plans = [
  'SALES_LED_PRO',
  'SALES_LED_PRO_PLUS',
  'SALES_LED_PRO_ENTERPRISE',
];
export const events_ecommerce_pro_plans = [
  'EVENTS_ECOMMERCE_PRO',
  'EVENTS_ECOMMERCE_PRO_PLUS',
];

export const enterprise_plans = ['ENTERPRISE'];
export const unlimited_plans = ['UNLIMITED'];

export const appsumo_plans = [
  'APPSUMO',
  'APPSUMO1',
  'APPSUMO2',
  'APPSUMO3',
  'APPSUMO4',
  'APPSUMO5',
  'APPSUMO6',
  'APPSUMO7',
  'APPSUMO8',
  'APPSUMO9',
  'APPSUMO10',
];
export const business_plans = [
  'BUSINESS',
  'BUSINESS_SIX_MONTHS',
  'BUSINESS_TWELVE_MONTHS',
  'BUSINESS_THREE_MONTHS',
];

export const essentials_plans = [
  'ESSENTIALS_100',
  'ESSENTIALS_500',
  'ESSENTIALS_1000',
  'ESSENTIALS_2000',
  'ESSENTIALS_3000',
  'ESSENTIALS_5000',
  'ESSENTIALS_7500',
  'ESSENTIALS_10000',
  'ESSENTIALS_20000',
];
export const ecommerce_plans = [
  'EVENTS_ECOMMERCE_100',
  'EVENTS_ECOMMERCE_500',
  'EVENTS_ECOMMERCE_1000',
];

export const ESSENTIALS_PLANS: Record<
  string,
  { maxAttendees: number; startingPrice?: number }
> = {
  '100': { maxAttendees: 100, startingPrice: 1490 },
  '500': { maxAttendees: 500, startingPrice: 4990 },
  '1000': {
    maxAttendees: 1000,
    startingPrice: 9490,
  },
  '2000': {
    maxAttendees: 2000,
  },
  '3000': {
    maxAttendees: 3000,
  },
  '5000': {
    maxAttendees: 5000,
  },
  '7500': {
    maxAttendees: 7500,
  },
  '10000': {
    maxAttendees: 10000,
  },
  '20000': {
    maxAttendees: 20000,
  },
};
